import React, { useState, useEffect, useMemo, useCallback } from 'react';
import GraphDaySelect from '../specific/GraphDaySelect';
import MultiWorkLineChart from '../specific/MultiWorkLineChart';
import {
    extractUniqueDaysFromReportData,
    buildMultiWorkChartData,
} from '../../usecases/graphMultiWorkUtils';

const getSourceItems = (workData) => workData?.[1]?.histPulv || [];
const getValue = (item) => (item.psi != null && !Number.isNaN(Number(item.psi)) ? Number(item.psi) : null);

const GraphPressao = ({ data, isPrinting }) => {
    const [selectedDay, setSelectedDay] = useState('');

    const uniqueDays = useMemo(
        () => extractUniqueDaysFromReportData(data, getSourceItems, 'data'),
        [data]
    );

    useEffect(() => {
        setSelectedDay((prev) => (!prev || !uniqueDays.includes(prev) ? (uniqueDays[0] || '') : prev));
    }, [uniqueDays]);

    const { chartData, series, yDomain } = useMemo(
        () => buildMultiWorkChartData({
            data,
            selectedDay,
            getSourceItems,
            dateField: 'data',
            getValue,
        }),
        [data, selectedDay]
    );

    const handleDayChange = useCallback((e) => setSelectedDay(e.target.value), []);

    return (
        <div>
            <h3>Variação de pressão em PSI durante o trabalho</h3>
            <GraphDaySelect
                selectedDay={selectedDay}
                uniqueDays={uniqueDays}
                onChange={handleDayChange}
                isPrinting={isPrinting}
            />
            <MultiWorkLineChart chartData={chartData} series={series} yDomain={yDomain} />
        </div>
    );
};

export default GraphPressao;
